import { AnnotationType } from 'components/AnnotatedElement/types'
import styled from 'styled-components'
import { Strings_DE } from './Strings_DE'
import { Strings_FR } from './Strings_FR'

const isMobile = window.innerWidth < 712

const Anno = styled.div<{ align?: 'left' | 'right' | 'center' }>`
  font-weight: 300;
  padding-top: 5px;
  color: #202346;
  font-size: 14px;
  text-align: ${({ align }) =>
    align === 'left' ? 'right' : align === 'center' ? 'center' : 'unset'};

  transform: ${({ align }) =>
    align === 'left'
      ? 'translate(100%,0)'
      : align === 'center'
      ? 'translate(50%,0)'
      : 'unset'};
`
const AnnoThwaites = styled.div<{ onDark?: boolean }>`
  font-weight: 700;
  padding-right: 10px;
  font-size: 18px;
  line-height: 1.2em;
  color: ${({ onDark }) => (onDark ? '#fff' : 'var(--petrol-main)')};
  white-space: nowrap;
  @media only screen and (max-width: 700px) {
    font-size: 15px;
    /* white-space: pre-wrap; */
  }
`
const AnnoRegion = styled.div`
  font-weight: 100;
  font-size: 30px;
  line-height: 1.3em;
  color: var(--brandblue-bright-3);
  color: var(--brandblue-bright-2);
  letter-spacing: 4px;
  text-transform: uppercase;
  font-style: italic;
  @media only screen and (max-width: 1000px) {
    font-size: 25px;
    letter-spacing: 2px;
  }
`
const PointMarker = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 3px;
  border-radius: 2px;
  background-color: var(--brandblue-bright-2);
`
const AnnoLevel2 = styled.div`
  font-size: 15px;
  line-height: 1.3em;
  color: var(--brandblue-bright-2);
  position: relative;
  padding-top: 5px;
  /* font-style: italic; */
  font-weight: 200;
  color: var(--beige-dark-2);
  letter-spacing: 0.5px;
  @media only screen and (max-width: 600px) {
    font-size: 15px;
  }
`
const AnnoLevel3 = styled.div`
  font-size: 15px;
  line-height: 1.3em;
  color: var(--brandblue-bright-3);
  position: relative;
  padding-top: 5px;
  font-style: italic;
  font-weight: 200;
  /* color: var(--beige-main); */
  letter-spacing: 0.5px;
  @media only screen and (max-width: 600px) {
    font-size: 13px;
    font-weight: 300;
  }
`

const AnnoColorScale = styled.div`
  position: relative;
  width: 600px;
  max-width: 65%;
  transform: translateX(-50%);
  background-color: var(--site-background);
  padding: 10px;
  line-height: 0;
  padding-top: 40px;
  padding-bottom: 10px;
  @media only screen and (max-width: 600px) {
    max-width: 320px;
    padding-top: 25px;
  }
  div {
    top: 15px;
    position: absolute;
    text-align: center;
    color: var(--text-color);
  }
  img {
    margin-top: 0px;
    max-width: 100%;
    @media only screen and (max-width: 600px) {
      margin-top: 4px;
    }
  }
`
const AnnoRegionCircle = styled.div<{ rad: number }>`
  display: inline-block;
  width: ${({ rad }) => rad + 'px'};
  height: ${({ rad }) => rad + 'px'};
  border-radius: ${({ rad }) => rad + '%'};
  border: 1.5px solid #fff;
`
const AnnoText = styled.div<{ onDark?: boolean }>`
line-height: 1.2em;
text-align: left;
color:#fff;
/* background-color: rgba(32, 35, 70,.5); */
text-shadow: #202346 0px 0px 2px , #202346 0px 0px 2px , #202346 0px 0px 2px ;
/* padding:10px; */

/* filter: drop-shadow(0px 0px 2px #202346); */

/* text-shadow: -1px -1px 0 #000, 1px -1px 0 #202346, -1px 1px 0 #202346, 1px 1px 0 #202346; */

font-size: 15px;

`
export const GetAnnotations = (
  lang: 'de' | 'fr',
  type: 'overview' | 'landmass'
) => {
  const locales = lang === 'fr' ? Strings_FR : Strings_DE
  const OverviewAnnotations: AnnotationType[] = [
    {
      left: 40,
      top: 44,
      anchor: 'right',
      connect: false,
      content: (
        <Anno>
          <AnnoThwaites>{locales.thwaitesglacier}</AnnoThwaites>
        </Anno>
      ),
    },
    {
      left: 52,
      top: 66,
      anchor: 'top',
      connect: false,
      content: (
        <Anno align='center'>
          <AnnoRegion>{locales.antarctica}</AnnoRegion>
        </Anno>
      ),
    },
    {
      left: 49.9,
      top: 49.1,
      distance: 0,
      anchor: 'bottom',
      connect: false,
      content: (
        <Anno align='center'>
          <AnnoLevel3>
            {locales.southpole}
            <PointMarker />
          </AnnoLevel3>
        </Anno>
      ),
    },
    // {
    //   left: 28,
    //   top: 4,
    //   distance: 0,
    //   anchor: 'bottom',
    //   connect: false,
    //   content: (
    //     <Anno align='center'>
    //       <AnnoLevel2>{locales.southamerica}</AnnoLevel2>
    //     </Anno>
    //   ),
    // },
    {
      left: 45,
      top: 22,
      distance: 0,
      anchor: 'left',
      connect: false,
      content: (
        <Anno align='center'>
          <AnnoLevel3>{locales.weddelsea}</AnnoLevel3>
        </Anno>
      ),
    },
    {
      left: 38,
      top: 68,
      distance: 0,
      anchor: 'left',
      connect: false,
      content: (
        <Anno align='center'>
          <AnnoLevel3>{locales.rossea}</AnnoLevel3>
        </Anno>
      ),
    },
  ]
  const LandmassAnnotations: AnnotationType[] = [
    // {
    //   left: 40,
    //   top: 44,
    //   anchor: 'right',
    //   connect: false,
    //   content: (
    //     <Anno>
    //       <AnnoThwaites onDark>{locales.thwaitesglacier}</AnnoThwaites>
    //     </Anno>
    //   ),
    // },
    {
      left: 29,
      top: isMobile?34:36,
      distance: 0,
      anchor: 'bottom',
      connect: false,
      content: (
        <Anno align='center'>
          <AnnoRegionCircle rad={isMobile?110:140} />
          <AnnoText onDark>{locales.belowsealevel}</AnnoText>
        </Anno>
      ),
    },
    // {
    //   left: 50,
    //   top: 47,
    //   anchor: 'top',
    //   connect: false,
    //   content: (
    //     <Anno align='center'>
    //       <AnnoRegion>{locales.antarctica}</AnnoRegion>
    //     </Anno>
    //   ),
    // },
    // {
    //   left: 49.9,
    //   top: 49.1,
    //   distance: 0,
    //   anchor: 'bottom',
    //   connect: false,
    //   content: (
    //     <Anno align='center'>
    //       <AnnoLevel2>
    //         {locales.southpole}
    //         <PointMarker />
    //       </AnnoLevel2>
    //     </Anno>
    //   ),
    // },
    {
      left: 50,
      top: 8,
      distance: 0,
      anchor: 'top',
      connect: false,
      content: (
        <Anno align='center'>
          <AnnoColorScale>
            <div style={{ left: '50%' }}>0</div>
            <div style={{ left: '10px' }}>-5000m</div>
            <div
              style={{
                left: 'calc(100% - 10px)',
                transform: 'translateX(-100%)',
              }}
            >
              5000m
            </div>
            <img src={require('../Assets/landwasser_colorscale.jpg')} />
          </AnnoColorScale>
        </Anno>
      ),
    },
    // {
    //   left: 45,
    //   top: 24,
    //   distance: 0,
    //   anchor: 'left',
    //   connect: false,
    //   content: (
    //     <Anno align='center'>
    //       <AnnoLevel3>{locales.weddelsea}</AnnoLevel3>
    //     </Anno>
    //   ),
    // },
    // {
    //   left: 38,
    //   top: 68,
    //   distance: 0,
    //   anchor: 'left',
    //   connect: false,
    //   content: (
    //     <Anno align='center'>
    //       <AnnoLevel3>{locales.rossea}</AnnoLevel3>
    //     </Anno>
    //   ),
    // },
  ]

  return type == 'overview' ? OverviewAnnotations : LandmassAnnotations
}
